export default __webpack_public_path__ + "static/media/hamza (1).1dc85381.jpg";